import PropTypes from 'prop-types'

export function Show({ when, children, fallback = null }) {
  return <>{when ? children : fallback}</>
}

Show.propTypes = {
  when: PropTypes.bool.isRequired,
  children: PropTypes.node,
  fallback: PropTypes.node,
}
